<template>
  <!-- Material form login -->
  <form v-on:submit.prevent>
    <p class="h4 text-center mb-4">Logowanie</p>
    <div class="grey-text">
      <mdb-input v-model="u" label="Użytkownik" icon="sign-in-alt" type="text" />
      <mdb-input v-model="p" label="Hasło" icon="lock" type="password" />
    </div>
    <div :v-model="msg" :key="kkk">{{msg}}</div>
    <div class="text-center">
      <mdb-btn @click="mthLoginButtonClick()">Zaloguj się</mdb-btn>
    </div>
  </form>
  <!-- Material form login -->
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
export default {
  name: "login",
  data() {
    return {
      u: "",
      p: "",
      msg: "",
      kkk: 0
    };
  },
  methods: {
    mthSaveToStore(userdata) {
      console.log('saving user to localstore');
      console.log(userdata);
      localStorage.setItem("swmLSuser", JSON.stringify(userdata));
      
    },
    mthLoginButtonClick() {


      var apiurl =
        this.$config.API_URL + "/login?a=" + this.u + "&b=" + this.p + "";
      console.log("Login, api url: " + apiurl);

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl
      })
        .then(function(response) {
          console.log("response:");
          console.log(response.data);

          if (!response.data.id && response == "error") {
            that.msg =
              "Nieprawidłowa nazwa użytkownika lub hasło (" +
              response.data +
              ").";
            console.log(that.u);
            console.log(that.msg);
            console.log(that.kkk++);
          } else if (!response.data.id) {
            that.msg = "Błąd API (" + response.data + ")";
          } else {
            that.mthSaveToStore(response.data);
            //location = "/warehouse";
            that.$router.replace('/warehouselive');

            that.msg = "Proszę czekać na przekierowanie do aplikacji...";
          }
        })
        .catch(function(error) {
          console.log(error);
          that.msg = "Brak połączenia z API (" + error + ").";
        });
    }
  },
  components: {
    mdbInput,
    mdbBtn
  }
};
</script>

<style scoped>
form {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20vh;
}
</style>